"use client";

import { IdentifierGenerator } from "@/components/identifier-generator";
import { useToolUi } from "@/components/tools/tool-ui";

/** English strings. A translated content file overrides these through `ui`. */
export const ARXIV_CITATION_GENERATOR_STRINGS = {
  howToCiteAnArxiv: "How to Cite an arXiv Preprint",
  n1CopyTheArxivId: "1. Copy the arXiv ID.",
  grabItFromTheTop:
    "Grab it from the top of the abstract page or the URL on arxiv.org. It looks like ",
  or: " or",
  httpsArxivOrgAbs2202: "https://arxiv.org/abs/2202.01037",
  n2PastePickAStyle: "2. Paste & pick a style.",
  dropTheArxivIdInto:
    "Drop the arXiv ID into the box above and choose APA, MLA, Chicago, IEEE, or any of the {styleCount} styles.",
  n3Cite: "3. Cite.",
  weResolveTheArxivId:
    " We resolve the arXiv ID to a full reference — authors, title, and year — and format it as a preprint for you. Edit any field, then copy or export it.",
} as const;

export default function ArxivCitationGeneratorWidget() {
  const strings = useToolUi(ARXIV_CITATION_GENERATOR_STRINGS);

  return (
    <>
      {/* Live generator (auto-detect, prefilled from ?arxiv=) */}
      <IdentifierGenerator param="arxiv" />
      {/* How to */}
      <section className="space-y-4">
        <h2 className="font-semibold text-foreground text-xl">
          {strings.howToCiteAnArxiv}
        </h2>
        <ol className="space-y-3 text-muted-foreground text-sm leading-relaxed">
          <li>
            <strong className="text-foreground">
              {strings.n1CopyTheArxivId}
            </strong>{" "}
            {strings.grabItFromTheTop}
            <span className="font-mono">2202.01037</span>
            {strings.or}{" "}
            <span className="font-mono">{strings.httpsArxivOrgAbs2202}</span>.
          </li>
          <li>
            <strong className="text-foreground">
              {strings.n2PastePickAStyle}
            </strong>{" "}
            {strings.dropTheArxivIdInto}
          </li>
          <li>
            <strong className="text-foreground">{strings.n3Cite}</strong>
            {strings.weResolveTheArxivId}
          </li>
        </ol>
      </section>
    </>
  );
}

/**
 * English only for now. Add locales here as this page type is translated — the
 * registry in src/lib/i18n/localized-routes.ts has to agree, or the proxy will
 * redirect the URL this generates away again.
 */
export function generateStaticParams() {
  return [{ locale: "en" }];
}

export const dynamicParams = false;
